import { authAxios } from "src/libs/axios/authAxios";
import {
  IDeleteServiceReq,
  IDescribeServiceReq,
  IDescribeServiceRes,
  IGetLicenseListReq,
  IGetServiceBillHistoryReq,
  IGetServiceListReq,
  IGetSiteNxacListReq,
  IGetSiteNxacListRes,
  IGetStatsReq,
  IGetUserNxacListReq,
} from "./types/cloud.type";

// GET
export const getServiceList = async ({
  offset,
  limit,
  order,
}: IGetServiceListReq): Promise<any> => {
  const response = await authAxios.get(
    `/console/cloud/service/list?offset=${offset}&limit=${limit}&order=${order}`
  );
  return response;
};

export const getLicenseList = async ({
  offset,
  limit,
  order,
}: IGetLicenseListReq): Promise<any> => {
  const response = await authAxios.get(
    `/console/cloud/license/list?offset=${offset}&limit=${limit}&order=${order}`
  );
  return response;
};
export const getDescribeService = async ({
  serviceUid,
}: IDescribeServiceReq): Promise<IDescribeServiceRes> => {
  const response = await authAxios.get(
    `/wapi/cloud/service/status/${serviceUid}`
  );
  return response.data;
};
export const getServiceBillHistory = async ({
  serviceUid,
}: IGetServiceBillHistoryReq): Promise<any> => {
  const response = await authAxios.get(
    `/console/cloud/service/bill/history/${serviceUid}`
  );
  return response;
};
export const getStats = async ({
  startDate,
  endDate,
  product,
}: IGetStatsReq): Promise<any> => {
  const response = await authAxios.get(
    `/console/cloud/service/stats?startDate=${startDate}&endDate=${endDate}&product=${product}`
  );
  return response;
};
export const getUserNxacList = async ({
  product,
}: IGetUserNxacListReq): Promise<any> => {
  const response = await authAxios.get(
    `/wapi/cloud/nxac/service/myList?product=${product}`
  );
  return response;
};
// 사이트에 등록된 Nxac리스트 조회
export const getSiteNxacList = async ({
  serviceUid,
}: IGetSiteNxacListReq): Promise<IGetSiteNxacListRes[]> => {
  const response = await authAxios.get(
    `/wapi/cloud/nxac/service/${serviceUid}/list`
  );
  return response.data;
};

// POST
export const getServiceOprionList = async (): Promise<any> => {
  const response = await authAxios.post(`/console/cloud/service/list`);
  return response;
};
export const startService = async (): Promise<any> => {
  const response = await authAxios.post(`/console/cloud/service/start`);
  return response;
};
export const stopService = async (): Promise<any> => {
  const response = await authAxios.post(`/console/cloud/service/stop`);
  return response;
};
export const terminateService = async (): Promise<any> => {
  const response = await authAxios.post(`/console/cloud/service/delete`);
  return response;
};
export const checkServiceId = async (): Promise<any> => {
  const response = await authAxios.post(`/console/cloud/service/check/url`);
  return response;
};
export const deleteService = async (req: IDeleteServiceReq): Promise<any> => {
  const response = await authAxios.post(`/wapi/cloud/service/delete`, req);
  return response;
};
export const setTotalPrice = async (): Promise<any> => {
  const response = await authAxios.post(
    `/console/cloud/service/bill/history/price`
  );
  return response;
};
